module.exports = __webpack_public_path__ + "img/ops.d4dd5486.svg";